module.exports = __webpack_public_path__ + "img/TZS09486.30039b6e.jpeg";